import React, { useState, useEffect } from 'react';
import { X, Aperture } from 'lucide-react';
import { getGalleryImages } from '../../services/api';
import EmberField from './EmberField';
import GalaxyDisc from './GalaxyDisc';

const CATEGORIES = [
  { id: 'all', label: 'All Work' },
  { id: 'events', label: 'Events' },
  { id: 'portraits', label: 'Portraits' },
  { id: 'landscapes', label: 'Landscapes' },
  { id: 'commercial', label: 'Commercial' },
  { id: 'fineart', label: 'Fine Art' },
];

const GalleryOrbitOverlay = ({ onClose, onSelect }) => {
  const [videoBroken, setVideoBroken] = useState(false);
  const [thumbs, setThumbs] = useState({});
  const [hoveredCat, setHoveredCat] = useState(null);

  useEffect(() => {
    getGalleryImages()
      .then((imgs) => {
        const map = {};
        if (imgs.length) map.all = imgs[0].thumbnail_url;
        imgs.forEach((img) => {
          const cats = Array.isArray(img.category) ? img.category : [img.category];
          cats.forEach((c) => {
            if (!map[c]) map[c] = img.thumbnail_url;
          });
        });
        setThumbs(map);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="xp-overlay" data-testid="gallery-orbit-overlay" onClick={onClose}>
      <GalaxyDisc anchorSel=".xp-overlay-device" centerY={0.6} excited={!!hoveredCat} />
      <EmberField focus={hoveredCat} count={40} sourceSel=".xp-overlay-device" targetPrefix="orbit-category-" />
      <button className="xp-overlay-close" onClick={onClose} data-testid="orbit-overlay-close" aria-label="Close">
        <X size={26} />
      </button>

      <div className="xp-overlay-stage" onClick={(e) => e.stopPropagation()}>
        <div className="xp-overlay-device" data-testid="orbit-device-video">
          {videoBroken ? (
            <div className="xp-popup-fallback">
              <Aperture size={90} strokeWidth={1} />
            </div>
          ) : (
            <video
              src="/experience/osmo_zoom.mp4"
              autoPlay
              muted
              loop
              playsInline
              onError={() => setVideoBroken(true)}
            />
          )}
        </div>

        {CATEGORIES.map((cat, i) => {
          const angle = (i * 360) / CATEGORIES.length - 90;
          const rad = (angle * Math.PI) / 180;
          return (
            <button
              key={cat.id}
              className="xp-cat-btn"
              style={{
                '--cx': Math.cos(rad).toFixed(3),
                '--cy': Math.sin(rad).toFixed(3),
                '--delay': `${120 + i * 90}ms`,
              }}
              onClick={() => {
                window.dispatchEvent(new Event('xp-burst'));
                onSelect(cat.id);
              }}
              onMouseEnter={() => setHoveredCat(cat.id)}
              onMouseLeave={() => setHoveredCat(null)}
              data-testid={`orbit-category-${cat.id}`}
            >
              {cat.label}
              {hoveredCat === cat.id && thumbs[cat.id] && (
                <span className="xp-cat-preview" data-testid={`orbit-preview-${cat.id}`}>
                  <img src={thumbs[cat.id]} alt="" />
                </span>
              )}
            </button>
          );
        })}
      </div>

      <p className="xp-overlay-hint">Choose a collection</p>
    </div>
  );
};

export default GalleryOrbitOverlay;
